import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemButton, ListItemText, Divider, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function BasicMenu() {

    // const dispatch = useDispatch()
    const navigate = useNavigate()

    const { navbarMenu } = useSelector((state) => state.menus)

    const menusWithQuickLinks = React.useMemo(() => {
        const source = Array.isArray(navbarMenu) ? navbarMenu : [];
        const orderCancellationExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/ordercancellation')
        );
        const kotPrintLogExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/kotprintlogreport')
        );
        const dineInTablesExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/dineintables')
        );
        const dineInTokensExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/dineintokens')
        );
        const promoCodesExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/promocodes')
        );
        const printBehaviorSettingsExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/printbehaviorsettings')
        );
        const customerAppThemeExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/customerapptheme')
        );
        const accountsExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/accounts')
        );
        const openingStockEntryExists = source.some((hm) =>
            (hm?.ArrSubMenu || []).some((sm) => String(sm?.menuURL || '').toLowerCase() === '/auditopeningstock')
        );

        if (orderCancellationExists && kotPrintLogExists && dineInTablesExists && dineInTokensExists && promoCodesExists && printBehaviorSettingsExists && customerAppThemeExists && accountsExists && openingStockEntryExists) return source;

        const list = source.map((hm) => ({ ...hm, ArrSubMenu: [...(hm.ArrSubMenu || [])] }));
        const stockIndex = list.findIndex((hm) => String(hm?.headMenu || '').toLowerCase().includes('stock'));
        const stockReportIndex = list.findIndex((hm) => {
            const head = String(hm?.headMenu || '').toLowerCase();
            return head.includes('stock report') || head.includes('reports');
        });
        const adminIndex = list.findIndex((hm) => String(hm?.headMenu || '').toLowerCase().includes('admin'));

        const cancelMenu = { subMenu: 'Order Cancellation', menuURL: '/OrderCancellation' };
        const kotPrintLogMenu = { subMenu: 'KOT Print Log Report', menuURL: '/KOTPrintLogReport' };
        const dineInTablesMenu = { subMenu: 'Dine In Tables', menuURL: '/DineInTables' };
        const dineInTokensMenu = { subMenu: 'Dine In Tokens', menuURL: '/DineInTokens' };
        const promoCodesMenu = { subMenu: 'Promo Code Management', menuURL: '/PromoCodes' };
        const printBehaviorSettingsMenu = { subMenu: 'Print Behavior Settings', menuURL: '/PrintBehaviorSettings' };
        const customerAppThemeMenu = { subMenu: 'Customer App Theme', menuURL: '/CustomerAppTheme' };
        const accountsMenu = { subMenu: 'Accounts Module', menuURL: '/Accounts' };
        const openingStockEntryMenu = { subMenu: 'Opening Stock Entry', menuURL: '/AuditOpeningStock' };

        if (!orderCancellationExists) {
            if (stockIndex >= 0) {
                list[stockIndex].ArrSubMenu.push(cancelMenu);
            } else {
                list.push({
                    headMenu: 'Stock Management',
                    ArrSubMenu: [cancelMenu]
                });
            }
        }

        if (!kotPrintLogExists) {
            if (stockReportIndex >= 0) {
                list[stockReportIndex].ArrSubMenu.push(kotPrintLogMenu);
            } else {
                list.push({
                    headMenu: 'Stock Reports',
                    ArrSubMenu: [kotPrintLogMenu]
                });
            }
        }

        if (!dineInTablesExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(dineInTablesMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [dineInTablesMenu]
                });
            }
        }

        if (!dineInTokensExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(dineInTokensMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [dineInTokensMenu]
                });
            }
        }

        if (!promoCodesExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(promoCodesMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [promoCodesMenu]
                });
            }
        }

        if (!printBehaviorSettingsExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(printBehaviorSettingsMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [printBehaviorSettingsMenu]
                });
            }
        }

        if (!customerAppThemeExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(customerAppThemeMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [customerAppThemeMenu]
                });
            }
        }

        if (!accountsExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(accountsMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [accountsMenu]
                });
            }
        }

        if (!openingStockEntryExists) {
            if (adminIndex >= 0) {
                list[adminIndex].ArrSubMenu.push(openingStockEntryMenu);
            } else {
                list.push({
                    headMenu: 'Admin Management',
                    ArrSubMenu: [openingStockEntryMenu]
                });
            }
        }

        return list;
    }, [navbarMenu]);

    return (
        <>
            {menusWithQuickLinks.map((hm, index) => (
                <Accordion key={index}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ minHeight: 32, '& .MuiAccordionSummary-content': { margin: 1 } }}
                    >
                        <Typography>{hm.headMenu}</Typography>
                    </AccordionSummary>
                    {hm.ArrSubMenu.map((sm, subIndex) => (
                        <AccordionDetails key={`${index}-${subIndex}`} sx={{ padding: '4px 8px' }}>
                            <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                <nav aria-label="main mailbox folders">
                                    <List sx={{ p: 0, m: 0 }}>
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <Divider sx={{ bgcolor: 'yellow' }} />
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <ListItem sx={{ p: 0, m: 0 }}>
                                            <ListItemButton sx={{ py: 0.5, px: 1 }} onClick={() => navigate(`${sm.menuURL}`)}>
                                                <ListItemText primaryTypographyProps={{ fontSize: 13 }} primary={`${sm.subMenu}`} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider sx={{ bgcolor: 'black' }} />
                                        <Divider sx={{ bgcolor: 'yellow' }} />
                                        <Divider sx={{ bgcolor: 'black' }} />
                                    </List>
                                </nav>
                            </Box>
                        </AccordionDetails>
                    ))}
                </Accordion>
            ))}
        </>
    );
}